module.exports = __webpack_public_path__ + "static/media/yyt.cc5ca1bc.png";